const ALLOWED_EXTENSIONS = new Set(['png', 'jpg', 'jpeg', 'gif', 'pdf', 'doc', 'docx', 'txt'])
const PREVIEWABLE_EXTENSIONS = new Set(['png', 'jpg', 'jpeg', 'gif'])

export const STUDENT_PHOTO_ACCEPT = '.png,.jpg,.jpeg,.gif,.pdf,.doc,.docx,.txt'
export const STUDENT_PHOTO_MAX_SIZE = 16 * 1024 * 1024
export const STUDENT_PHOTO_HINT = '支持 png/jpg/jpeg/gif/pdf/doc/docx/txt，最大 16MB'

function getExtension(value = '') {
  const normalized = String(value || '').trim().toLowerCase()
  const index = normalized.lastIndexOf('.')
  return index === -1 ? '' : normalized.slice(index + 1)
}

export function getStudentPhotoFileName(path = '') {
  const normalized = String(path || '').trim()
  if (!normalized) return ''
  return normalized.split('/').pop() || normalized
}

export function isPreviewableStudentPhoto(path = '') {
  return PREVIEWABLE_EXTENSIONS.has(getExtension(path))
}

export function validateStudentPhotoFile(file) {
  if (!file) return '请选择要上传的照片文件'

  const ext = getExtension(file.name)
  if (!ALLOWED_EXTENSIONS.has(ext)) {
    return '仅支持 png、jpg、jpeg、gif、pdf、doc、docx、txt 格式'
  }

  if (Number(file.size || 0) > STUDENT_PHOTO_MAX_SIZE) {
    return '文件大小不能超过 16MB'
  }

  return ''
}
